import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './application.tsx';
import { observability } from './config/observability';
import { overrideNodePrototypeMethods } from './shared/utils';

const start = async () => {
  observability.start();
  overrideNodePrototypeMethods();
  console.log('start');
};

start().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
